import { Injectable } from '@angular/core';
import { Observable, defer, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  PropertyGroup,
  PropertyGroupContainer,
} from '@alfresco/adf-content-services/lib/content-metadata/interfaces/property-group.interface';

import { ExternalMetadataApiService } from './external-metadata-api.service';
import { WkAlfrescoApiService } from './wk-alfresco-api.service';

@Injectable({
  providedIn: 'root',
})
export class WkPropertyDescriptorsService {
  constructor(
    private readonly apiService: WkAlfrescoApiService,
    private readonly externalMetadataApiService: ExternalMetadataApiService
  ) {}

  load(groupNames: string[]): Observable<PropertyGroupContainer> {
    const groupFetchStreams = groupNames
      .map((groupName) => groupName.replace(':', '_'))
      .map((groupName) =>
        defer(() => {
          if (
            groupName.startsWith(
              this.externalMetadataApiService.externalMetadataPrefix
            )
          ) {
            return this.externalMetadataApiService.getExternalsClass(groupName);
          } else {
            return this.apiService.classesApi.getClass(groupName);
          }
        })
      );

    return forkJoin(groupFetchStreams).pipe(map(this.convertToObject));
  }

  private convertToObject(
    propertyGroupsArray: PropertyGroup[]
  ): PropertyGroupContainer {
    return propertyGroupsArray.reduce(
      (propertyGroups, propertyGroup) =>
        Object.assign({}, propertyGroups, {
          [propertyGroup.name]: propertyGroup,
        }),
      {}
    );
  }
}
